import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft, GraduationCap, Users, Trophy, Calendar } from "lucide-react";

export default function AcademyPlaceholder() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0f1a] p-4">
      <div className="max-w-4xl mx-auto py-8">
        <div className="flex items-center justify-between mb-6">
          <Button
            onClick={() => navigate("/")}
            variant="ghost"
            className="text-blue-400 hover:text-blue-400"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </Button>
        </div>

        <Card className="p-12 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-blue-500/20 rounded-full p-6">
              <GraduationCap className="w-24 h-24 text-blue-400" />
            </div>
          </div>

          <h1 className="text-4xl font-bold text-white mb-4">🎓 SCC Football Academy</h1>
          <p className="text-xl text-slate-300 mb-8">Coming Soon!</p>

          <div className="bg-blue-500/10 rounded-lg p-8 mb-8 text-left max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-white mb-4">What to Expect:</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Users className="w-6 h-6 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-white">Youth Development</h3>
                  <p className="text-slate-400">Professional coaching for ages U8 to U14</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Trophy className="w-6 h-6 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-white">Competitive Teams</h3>
                  <p className="text-slate-400">Multiple age groups competing in local leagues</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Calendar className="w-6 h-6 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-white">Structured Training</h3>
                  <p className="text-slate-400">Regular training sessions and skill development programs</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-yellow-500/10 border-2 border-white/5 rounded-lg p-6 mb-8">
            <h3 className="text-xl font-semibold text-white mb-2">Interested in Enrolling Your Child?</h3>
            <p className="text-slate-300 mb-4">
              The Academy enrollment portal is currently under development. Parents will be able to register their children and make payments directly through this platform.
            </p>
            <p className="text-sm text-slate-400">
              For immediate inquiries, please contact: <strong>academy@sccfootball.com</strong>
            </p>
          </div>

          <div className="flex gap-4 justify-center">
            <Button
              onClick={() => navigate("/")} 
              size="lg"
              className="bg-blue-600 hover:bg-blue-700"
            >
              Back to Home
            </Button>
            <Button
              onClick={() => window.location.href = "mailto:academy@sccfootball.com"}
              size="lg"
              variant="outline"
              className="border-2 border-blue-600 text-blue-400 hover:bg-blue-500/10"
            >
              Contact Us
            </Button>
          </div>

          <div className="mt-8 text-sm text-slate-400">
            <p>🚧 This section is under active development</p>
            <p>Check back soon for enrollment options!</p>
          </div>
        </Card>
      </div>
    </div>
  );
}
